export default {
  pageTitle: 'Planlama',
  blocks: 'Bloklar',
  blockId: 'Blok ID',
  searchPlaceholder: 'Blok, tedarikçi, araç veya sürücü ara',
  tabs: {
    blocks: 'Bloklar',
    drivers: 'Sürücüler',
    vehicles: 'Araçlar',
  },
  columns: {
    block: 'Blok',
    serviceProvider: 'Servis Sağlayıcı',
    driver: 'Sürücü',
    vehicle: 'Araç',
  },
  tooltip: {
    routeDay: 'Sefer günü',
    departureLocation: 'Kalkış Noktası',
    plannedActDpt: 'Planlanan/Gerçek Kalkış',
    arrivalLocation: 'Varış Noktası',
    plannedActArr: 'Planlanan/Gerçek Varış',
    days: 'Günler',
    status: 'Durum',
    delayTime: 'Gecikme süresi',
    reservations: 'Rezervasyonlar',
    blockId: 'Blok ID',
    startingTime: 'Başlangıç Saati',
    endingTime: 'Bitiş Saati',
    totalWorkingTime: 'Toplam Çalışma Süresi',
    totalAssignments: 'Toplam Atama',
    reservationCount: 'Planlanan Yolcu Sayısı',
  },
  status: {
    CREATED: 'Başlamadı',
    STARTED: 'Başladı',
    COMPLETED: 'Tamamlandı',
    CANCELLED: 'İptal Edildi',
    ACTIVE_ON_TIME: 'Zamanında',
    ACTIVE_DELAYED: 'Gecikmeli',
    CANCELED_NO_RESERVATION: 'İptal (Rezervasyon Yok)',
    CANCELED_BY_ADMIN: 'Yönetici Tarafından İptal',
  },
  legend: {
    inbound: 'Gidiş',
    outbound: 'Dönüş',
    loop: 'Döngü',
    activeOnTime: 'Zamanında',
    activeDelayed: 'Gecikmeli',
    completed: 'Tamamlandı',
    canceledNoReservation: 'Rezervasyon olmadığı için iptal',
    canceledByAdmin: 'Yönetici tarafından iptal',
    numberOfReservations: 'Rezervasyon sayısı',
  },
  alertBar: {
    message:
      "Tek bir tarih için değişiklik yapmak için, istediğiniz blokların kaynaklarını düzenleyin ve son programdan memnun kaldığınızda Uygula'ya tıklayın.",
    message2:
      "Değişiklikleri bir tarih aralığına uygulamak için sadece bir bloğu güncelleyin, Uygula'ya tıklayın ve değişikliğin uygulanacağı tarihleri ve günleri seçin.",
    revertChanges: 'Değişiklikleri Geri Al',
    apply: 'Uygula',
  },
  multiBlockConfirm: {
    title: 'Değişiklikleri Onayla',
    message: 'Düzenlenen blokların programlarını değiştirmek istediğinizi lütfen onaylayın.',
    change: 'Değiştir',
    cancel: 'İptal',
  },
  singleBlockEdit: {
    title: 'Atamaları Düzenle',
    cancel: 'İptal',
    confirm: 'Onayla',
    save: 'Kaydet',
    on: 'tarihinde',
    betweenDates: 'tarihler arasında',
    permanently: 'kalıcı olarak',
    start: 'Başlangıç',
    end: 'Bitiş',
    startDate: 'Başlangıç Tarihi',
    endDate: 'Bitiş Tarihi',
    days: 'Günler',
    changeDriverDesc:
      '{blockId} bloğunun sürücüsünü {from} yerine {to} olarak değiştirmek istediğinizi lütfen onaylayın.',
    changeVehicleDesc:
      '{blockId} bloğunun aracını {from} yerine {to} olarak değiştirmek istediğinizi lütfen onaylayın.',
    confirmChanges: '{blockId} bloğu için atamaları değiştirmek istediğinizi lütfen onaylayın.',
  },
  assignmentConflict: 'Atama Çakışması',
  assignmentConflictMessage: 'Bazı blokların atamalarında çakışma bulduk. Lütfen inceleyin ve tekrar deneyin.',
  bulkAssignmentConflictMessage:
    '{blockIds} bloklarının atamalarında çakışma bulduk. Lütfen inceleyin ve tekrar deneyin.',
  newBlock: {
    buttonLabel: 'Yeni Blok',
    title: 'Yeni Blok Oluştur',
    blockIdLabel: 'Blok ID',
    blockIdPlaceholder: 'Blok ID girin',
    displayNameLabel: 'Görünen Ad',
    displayNamePlaceholder: 'Görünen ad girin',
    successMessage: 'Blok başarıyla oluşturuldu',
    addedSuccessfully: 'Blok başarıyla eklendi',
    addedSuccessfullyLong: 'Blok yaratıldı. Görüntülemek için bir sefer atamanız gerekmektedir.',
    errorMessage: 'Blok oluşturulamadı',
    duplicateBlockId: 'Bu Blok ID ile kayıtlı bir blok zaten mevcut. Blok ID benzersiz olmalıdır.',
  },
  editBlock: {
    title: 'Bloğu Düzenle',
    updatedSuccessfully: 'Blok başarıyla güncellendi',
    errorMessage: 'Blok güncellenemedi',
  },
  deleteBlock: {
    confirmTitle: 'Bloğu Sil',
    confirmText: 'Bu bloğu silmek istediğinizden emin misiniz?',
    confirmWithAssignmentsText:
      'Bu bloğa atanmış seferler bulunmaktadır. Silme işlemi öncesinde ilgili seferleri kontrol ediniz.',
    confirmButton: 'Sil',
    cancelButton: 'İptal',
    successMessage: 'Blok başarıyla silindi',
    errorMessage: 'Blok silinemedi',
  },
};
